import React from "react";
import { TRMargenConceptoConsolidado } from "./TRMargenConceptoConsolidado";

export const TRMargenConsolidado = ({ linea, data, guia }) => {
  return (
    <>
      <tr>
        <td className="sticky-row-mw-150  col-default grupo brd-l">
          {linea}
        </td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo"></td>
        <td className="grupo brd-r"></td>
      </tr>
      <TRMargenConceptoConsolidado
        linea={"Utilidad Bruta"}
        className={"concepto sticky-row-mw-80  col-default brd-l brd-r"}
        classNameTitulo={"concepto sticky-row-mw-150 col-default brd-l brd-r"}
        data={data.filter((item) => item.departamento === "UTILIDAD BRUTA")}
        guia={guia.filter((item) => item.departamento === "UTILIDAD BRUTA")}
        concepto={"Utilidad bruta"}
        color={"menos"}
      />
      <TRMargenConceptoConsolidado
        linea={"Gastos Departamentales"}
        className={"concepto sticky-row-mw-80  col-default brd-l brd-r bck-dif"}
        classNameTitulo={"concepto sticky-row-mw-150 col-default brd-l brd-r bck-dif"}
        data={data.filter((item) => item.departamento === "GASTOS DEPARTAMENTALES")}
        guia={guia.filter((item) => item.departamento === "GASTOS DEPARTAMENTALES")}
        concepto={"Gastos"}
        color={"mas"}
      />
      <TRMargenConceptoConsolidado
        linea={"Gastos de Administración"}
        className={"concepto sticky-row-mw-80  col-default brd-l brd-r"}
        classNameTitulo={"concepto sticky-row-mw-150 col-default brd-l brd-r"}
        data={data.filter((item) => item.departamento === "ADMINISTRACIÓN")}
        guia={guia.filter((item) => item.departamento === "GASTOS DE ADMINISTRACION")}
        concepto={"Gasto"}
        color={"mas"}
      />
      <TRMargenConceptoConsolidado
        linea={"Gastos STAF"}
        className={"concepto sticky-row-mw-80  col-default brd-l brd-r bck-dif"}
        classNameTitulo={"concepto sticky-row-mw-150 col-default brd-l brd-r bck-dif"}
        data={data.filter((item) => item.departamento === "STAFF")}
        guia={guia.filter((item) => item.departamento === "GASTOS DE STAFF")}
        concepto={"Gasto"}
        color={"mas"}
      />
      <TRMargenConceptoConsolidado
        linea={"Gastos de Finanzas"}
        className={"concepto sticky-row-mw-80  col-default brd-l brd-r"}
        classNameTitulo={"concepto sticky-row-mw-150 col-default brd-l brd-r"}
        data={data.filter((item) => item.departamento === "FINANZAS")}
        guia={guia.filter((item) => item.departamento === "GASTOS DE FINANZAS")}
        concepto={"Gasto"}
        color={"mas"}
      />
      <TRMargenConceptoConsolidado
        linea={"Utilidad de Operación"}
        className={"concepto sticky-row-mw-80  col-default brd-l brd-r bck-dif"}
        classNameTitulo={"concepto sticky-row-mw-150 col-default brd-l brd-r bck-dif"}
        data={data.filter((item) => item.departamento === "UTILIDAD DE OPERACION")}
        guia={guia.filter((item) => item.departamento === "UTILIDAD DE OPERACION")}
        concepto={"Gasto"}
        color={"menos"}
      />
      <TRMargenConceptoConsolidado
        linea={"Sueldos"}
        className={"concepto sticky-row-mw-80  col-default brd-l brd-r bck-sueldo"}
        classNameTitulo={"concepto sticky-row-mw-150 col-default brd-l brd-r bck-sueldo"}
        data={data.filter((item) => item.departamento === "SUELDOS")}
        guia={guia.filter((item) => item.departamento === "SUELDOS")}
        prop={"nomina"}
        formatodinero={true}
        operador={""}
        concepto={"Sueldos"}
        color={"mas"}
      />
      <TRMargenConceptoConsolidado
        linea={""}
        className={"concepto sticky-row-mw-80  col-default brd-l brd-b brd-r bck-sueldo"}
        classNameTitulo={"concepto sticky-row-mw-150 col-default brd-l brd-b brd-r bck-sueldo"}
        data={data.filter((item) => item.departamento === "SUELDOS")}
        guia={guia.filter((item) => item.departamento === "SUELDOS")}
        prop={"porc_nomina"}
        concepto={"Porcentaje sueldos"}
        color={"mas"}
      />
      <tr style={{ height: "20px" }}></tr>
    </>
  );
};
